import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';

/**
 * @usage
 *
 * ```html
 * <tag tag="h1"></tag>
 * ```
 *
 * @author Rafał Wolak <rafal@tomandco.co.uk>
 * @export
 * @class TagComponent
 */
@Component({
    selector: 'tag, [tag]',
    template: `
        @switch (tag) {
            @case ('h1') {
                <h1><ng-container [ngTemplateOutlet]="content"></ng-container></h1>
            }
            @case ('h2') {
                <h2><ng-container [ngTemplateOutlet]="content"></ng-container></h2>
            }
            @case ('h3') {
                <h3><ng-container [ngTemplateOutlet]="content"></ng-container></h3>
            }
            @case ('h4') {
                <h4><ng-container [ngTemplateOutlet]="content"></ng-container></h4>
            }
            @case ('h5') {
                <h5><ng-container [ngTemplateOutlet]="content"></ng-container></h5>
            }
            @case ('h6') {
                <h6><ng-container [ngTemplateOutlet]="content"></ng-container></h6>
            }
            @case ('p') {
                <p><ng-container [ngTemplateOutlet]="content"></ng-container></p>
            }
            @default {
                <ng-container [ngTemplateOutlet]="content"></ng-container>
            }
        }
        <ng-template #content><ng-content></ng-content></ng-template>
    `,
    standalone: true,
    imports: [CommonModule, NgTemplateOutlet]
})
export class TagComponent {
    @Input('tag')
    tag?: string;
}
